import { Link } from "react-router-dom"

import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { DesignSubItem } from "@/domains/navigation/subitems/design-subitem"
import { DesignComponentsSubItem } from "@/domains/navigation/subitems/design-components-subitem"

export const DESIGN_BREADCRUMB_ITEMS = [new DesignSubItem(), new DesignComponentsSubItem()]

const DesignComponentsPage = () => {
  return (
    <PageContainer>
      <MetaData title="Design | Components" />
      <PageTitle title="Components" subTitle="Configure component colors and styles" items={DESIGN_BREADCRUMB_ITEMS} />

      <div className="text-t100 flex flex-col gap-4">
        <Link to="/design/components/table" className="hover:text-p100-light">
          Table
        </Link>
      </div>
    </PageContainer>
  )
}

export default DesignComponentsPage

